<template>
  <PrePeersLegalDocument
    :title="t('legalPages.termsOfUse.pageTitle')"
    :highlighted-title-part="t('legalPages.termsOfUse.highlightedTitlePart')"
    :version-label="t('legalPages.termsOfUse.versionLabel')"
    :html="termsOfUseHtml" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import termsOfUseHtml from '~/assets/legal/conditions-generales-utilisation.html?raw'
import PrePeersLegalDocument from '~/components/sections/PrePeersLegalDocument.vue'

const { t } = useI18n()

definePageMeta({
  layout: 'default',
})

useSeoMeta({
  title: computed(() => t('legalPages.termsOfUse.metaTitle')),
  description: computed(() => t('legalPages.termsOfUse.metaDescription')),
  ogTitle: computed(() => t('legalPages.termsOfUse.metaTitle')),
  ogDescription: computed(() => t('legalPages.termsOfUse.metaDescription')),
})
</script>
